
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { PriceTypeSource } from '@/Sources';

  @Component({
    name: 'price-type-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class PriceTypeDropdownField extends Vue {
    @Prop() public value!: number;
    @Prop({ default: 'Price Type' }) public label!: string;
    @Prop({ default: '' }) public errorText!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;
    @Prop({ type: Boolean, default: false }) public required!: boolean;

    public source: PriceTypeSource = new PriceTypeSource();

    public get val(): number { return this.value; }
    public set val(value: number) {
      this.$emit('input', value);
    }
  }
